import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {

  userLoggedIn: boolean = false;
  loaderSubscription: Subscription;

  constructor(
    private authService: AuthService,
    public loaderService: LoaderService
  ) {
    this.loaderSubscription = this.loaderService.watchLoader.subscribe((response) => {
      this.loaderService.showLoader = response;
    });
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((logged_in) => {
      this.userLoggedIn = logged_in;
    });
  }

  ngOnDestroy() {
    this.loaderSubscription.unsubscribe();
  }

}
